// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-table-status-icon-large.bolt-header-icon.l {
    margin-top: 4px;
}

@media screen and (max-width: 700px) {
    .header-example-advanced {
        flex-wrap: wrap;
    }

    .header-example-advanced .bolt-header-commandbar {
        flex-basis: 100%;
        margin-left: 40px;
        margin-top: 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Docs/Components/Header/examples/Header.Example.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;IACnB;AACJ","sourcesContent":[".bolt-table-status-icon-large.bolt-header-icon.l {\r\n    margin-top: 4px;\r\n}\r\n\r\n@media screen and (max-width: 700px) {\r\n    .header-example-advanced {\r\n        flex-wrap: wrap;\r\n    }\r\n\r\n    .header-example-advanced .bolt-header-commandbar {\r\n        flex-basis: 100%;\r\n        margin-left: 40px;\r\n        margin-top: 8px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
